<template>
  <div class="page-wrapper" ref="rootDiv">
  <img src="../image/ajax-loader.gif" v-show="waitingApiRequestsCount != 0"
       style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
  <alert-window ref="alertWindow"></alert-window>
  <main-service :isVisible="isMainServiceWindowVisible"
                     :serviceNr="mainServiceNr"
                     :serviceIndex="serviceIndex"
                     :isNew="addingNewService"
                     :addresses="validAddresses"
                     :autoDistance="autoDistance"
                     :manualDistance="manualDistance"
                     :clientAddresses="order.client.addresses"
                     :orderDateTime = "order.datetime"
                     :orderStatus="order.status"
                     @close-window="changeMainServiceWindowVisibility"></main-service>
  <additional-service :isVisible="isAdditionalServiceWindowVisible"
                           :index="serviceIndex"
                           :isNew="addingNewService"
                           :orderDateTime = "order.datetime"
                           @close-window="changeAdditionalServiceWindowVisibility"></additional-service>
  <prepayment :isVisible="isPrepaymentWindowVisible"
                   :isNew="addingNewPrepayment"
                   :index="prepaymentIndex"
                   @close-window="changePrepaymentWindowVisibility"></prepayment>

  <worker-list :isVisible="isWorkerListWindowVisible"
               :type="needfulWorkerType"
               :serviceArrayFromOrder="serviceArrayForWorkerList"
               :serviceArrayIndex="serviceArrayIndexForWorkerList"
               :categoryName="categoryNameForWorkerList"
               :categoryId="categoryIdForWorkerList"
               :isCash="order.cash"
               @close-window="changeWorkerListWindowVisibility"></worker-list>
  <shipping-packing
    :isVisible="isShippingPackingWindowVisible"
    :index="serviceIndex"
    :addressesFromOrder="validAddresses"
    @close-window="changeShippingPackingWindowVisibility"></shipping-packing>
  <address-contact-person />
        <menu-dispatcher></menu-dispatcher>
        <div class="wrapper">
            <header-dispatcher></header-dispatcher>
            <div class="request-container">
                <div class="request">
                    <div class="request-head visibility">
                        <div class="request-id">{{orderName}}</div>
                        <div class="request-avtor">
                            <span class="title">Автор:</span>
                          <span class="name">{{ order.authorName }},</span><span class="date">{{ moment(order.dateOfCreation).lang('ru').format('ll') }}</span>
                        </div>
                      <div class="request-status change-status" @click="editProhibited ? '' : openStatusMenu()">
                            <span class="active-status" :class="[statusClass]">{{statusText}}<i class="fa fa-angle-down" v-if="[4, 5].indexOf(initialStatus) == -1" /></span>
                        <ul class="request-list small"
                            ref="statusList"
                            v-if="[4, 5].indexOf(initialStatus) == -1">
                              <li class="green-status"
                                  v-if="(!initialStatus || [0, 1, 2].indexOf(initialStatus) != -1) && order.status != 0"
                                  @click="choseStatus(0)">Принята
                              </li>
                              <li class="yellow-status"
                                  v-if="[0, 1, 2, 3, 6, 7, 8].indexOf(initialStatus) != -1 && order.status != 1"
                                  @click="choseStatus(1)">Ожидает
                              </li>
                              <li class="red-status rejected-status"
                                  v-if="[0, 1, 2, 3, 6, 7, 8].indexOf(initialStatus) != -1 && order.status != 2"
                                  @click="choseStatus(2)">Отклонена
                              </li>
                              <li class="light-blue-status"
                                  v-if="initialStatus == 3 && order.status != 3"
                                  @click="choseStatus(3)">Распределена
                              </li>
                              <li class="orange-status"
                                  v-if="initialStatus == 6 && order.status != 6"
                                  @click="choseStatus(6)">Рабочие подтверждены
                              </li>
                              <li class="violet-status"
                                  v-if="initialStatus == 7 && order.status != 7"
                                  @click="choseStatus(7)">Начали
                              </li>
                              <li class="brown-status"
                                  v-if="initialStatus == 8 && order.status != 8"
                                  @click="choseStatus(8)">Прогноз получен
                              </li>
                            </ul>
                        </div>
                    </div>
                    <div class="request-body">
                        <div class="request-info">
                            <div class="sections page-scroll">
                                <section class="request-main section-open" ref="mainSection">
                                    <div class="section-head" @click="openMainSection(false)">Основная информация
                                        <a name="request-main" id="request-main" class="anchor"></a>
                                    </div>

                                    <div class="section-body">
                                        <div class="fieldset">
                                            <label class="fieldset-title">Дата</label>
                                            <fieldset>
                                                <date-picker
                                                        v-model="date"
                                                        ref="datePicker"
                                                        format="DD.MM.YYYY"
                                                        lang="ru"
                                                        v-mask="'##.##.####'"
                                                        placeholder="__.__.____"
                                                        :clearable="false"
                                                        :first-day-of-week="1">
                                                </date-picker>
                                            </fieldset>
                                        </div>
                                        <div class="fieldset">
                                            <label class="fieldset-title">Время</label>
                                            <fieldset>
                                              <input type="text" class="time" placeholder="hh:mm" v-mask="'##:##'" v-model="time">
                                            </fieldset>
                                        </div>
                                        <div class="fieldset payment-method">
                                            <label class="fieldset-title">Расчет</label>
                                            <div class="switch">
                                                <span class="payment-method-item"
                                                      @click="changePaymentType(true)"
                                                      :class="{active: order.cash === true}">Наличный</span>
                                                <div class="switch_bg"
                                                     :class="{'blocked': order.cash !== true && order.cash !== false}"
                                                     @click="changePaymentType()">
                                                    <span :class="{'location-right': !order.cash}"></span>
                                                </div>
                                                <span class="payment-method-item"
                                                      @click="changePaymentType(false)"
                                                      :class="{active: order.cash === false}">Безналичный</span>
                                            </div>
                                        </div>
                                        <div class="fieldset payment-checkbox" v-if="!order.cash">
                                            <label class="checkbox-label"><input type="checkbox"
                                              v-model="order.prepaymentRequired">Предоплата обязательна</label>
                                        </div>
                                      <div class="fieldset check-checkbox" v-if="order.cash">
                                        <label class="checkbox-label"><input type="checkbox"
                                                                             v-model="order.byCheck">По чеку</label>
                                      </div>
                                        <div class="fieldset">
                                            <label class="fieldset-title obligatorily">Телефон</label>
                                          <fieldset>
                                            <input type="text"
                                                   v-model="order.client.phone"
                                                   v-mask="'+7 (###) ###-##-##'"
                                                   placeholder="'+7 (___) ___ - __ - __"
                                                   @change="setNullClientPhone">
                                            <ul class="drop-down-list" :style="phonesListStyle">
                                              <li v-for="(phone, i) in phones" :key="i"
                                                  @click="editProhibited ? '' : choosePhone(i)">
                                                {{phone}}
                                              </li>
                                            </ul>
                                          </fieldset>
                                        </div>
                                        <div class="fieldset">
                                            <label class="fieldset-title">Клиент</label>
                                            <fieldset><input type="text" v-model="order.client.name" placeholder="Имя, отчество"></fieldset>
                                        </div>
                                        <div class="fieldset">
                                            <label class="checkbox-label"><input type="checkbox" v-model="order.client.org">Клиент юридическое лицо</label>
                                        </div>
                                        <div class="fieldset" v-if="canCompleteOrder">
                                          <button type="button" class="request-complete"
                                                  @click="editProhibited ? '' : onOrderComplete()">Подтвердить оплату
                                          </button>
                                        </div>
                                    </div>
                                </section>
                                <section class="request-client" ref="clientSection">
                                    <div class="section-head" @click="openClientSection(false)">Клиент
                                        <a href="request-client" id="request-client" class="anchor"></a>
                                    </div>

                                    <div class="section-body">
                                        <div class="fieldset">
                                            <label class="fieldset-title">Email</label>
                                          <fieldset><input v-validate="'email'" name="email" type="text"
                                                           v-model="order.client.email">
                                            <span
                                              v-show="errors.first('email')">Введенный почтовый адрес некорректен</span>
                                          </fieldset>
                                        </div>
                                        <div class="firm-requisites" v-if="order.client.org">
                                            <div class="fieldset">
                                                <label class="fieldset-title">Организация</label>
                                                <fieldset><input type="text" v-model="order.client.orgName"></fieldset>
                                            </div>
                                            <div class="fieldset">
                                                <label class="fieldset-title">ИНН</label>
                                                <fieldset><input type="text" v-model="order.client.orgInn"></fieldset>
                                            </div>
                                            <div class="fieldset">
                                                <label class="fieldset-title">КПП</label>
                                                <fieldset><input type="text" v-model="order.client.orgKpp"></fieldset>
                                            </div>
                                            <div class="fieldset">
                                                <label class="fieldset-title">Юр. адрес</label>
                                                <fieldset><input type="text" v-model="order.client.orgAddress"></fieldset>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section class="request-address section-open" ref="addressSection">
                                    <div class="section-head"  @click="openAddressSection(false)">Адреса
                                        <a href="request-address" id="request-address" class="anchor"></a>
                                    </div>

                                    <div class="section-body address-section">
                                        <draggable v-model="addresses" :options="{handle:'.handle'}">
                                          <Address v-for="(address, i) in addresses"
                                                   :key="'order-address-' + i"
                                                   :order="i"
                                                   :editable="!editProhibited"
                                                   :clientAddresses="order.client.addresses"
                                                   :isForPetrolService="false"></Address>
                                        </draggable>
                                        <div class="fieldset">
                                          <div class="add-address" @click="editProhibited ? '' : addAddress()">
                                            <span class="icon">+</span><span>Добавить адрес</span>
                                          </div>
                                        </div>
                                      <Route />
                                        <div class="fieldset distance">
                                            <label class="fieldset-title">Расстояние</label>
                                            <fieldset><input type="number" v-model="manualDistance" min="0"></fieldset>
                                            <div class="distance-auto"><span>~</span> {{autoDistance}} <span class="km">км</span></div>
                                        </div>
                                    </div>
                                </section>
                              <section class="request-service section-open" ref="itemsSection">
                                <div class="section-head" @click="openItemsSection(false)">Услуги
                                  <a href="request-service" id="request-service" class="anchor"></a>
                                </div>
                                <div class="section-body">
                                  <div class="service-block">
                                    <div class="add-service">
                                      <label>Основные услуги</label>
                                      <button type="button" class="add-main-service"
                                              @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, null, null, true)">
                                        <i>+</i>Добавить
                                      </button>
                                      <div class="application-time" title="Посмотреть"
                                           v-show="order.status != null"
                                           @click="showOrderTimes = !showOrderTimes"><span><i
                                        class="fa fa-hourglass-o"></i>Время заявки <i
                                        class="fa fa-angle-down"></i></span></div>
                                    </div>
                                    <div v-show="showOrderTimes">
                                      <div class="application-time-form">
                                        <div class="string visibility">
                                          <div class="name">Фактическое время начала работ</div>
                                          <div class="apply-to-all" title="Применить ко всем"
                                               @click="editProhibited ? '' : setOrderRealStartTimeToEachService()"><i
                                            class="fa fa-level-down"></i>ко всем
                                          </div>
                                          <fieldset class="value">
                                            <input type="text" placeholder="hh:mm" v-model="orderRealStartTime" v-mask="'##:##'">
                                          </fieldset>

                                        </div>
                                        <div class="string visibility">
                                          <div class="name">Фактическое время окончания работ</div>
                                          <div class="apply-to-all" title="Применить ко всем"
                                               @click="editProhibited ? '' : setOrderRealEndTimeToEachService()"><i
                                            class="fa fa-level-down"></i>ко всем
                                          </div>
                                          <fieldset class="value">
                                            <input type="text" placeholder="hh:mm" v-model="orderRealEndTime" v-mask="'##:##'">
                                          </fieldset>
                                        </div>
                                        <div class="string visibility">
                                          <div class="name">Фактическая продолжительность работ</div>
                                          <fieldset class="value no-apply">
                                            <input type="text" v-model="orderDuration" readonly>
                                            <span>час.</span>
                                          </fieldset>
                                        </div>
                                        <div class="string visibility">
                                          <div class="name">Прогноз</div>
                                          <div class="apply-to-all" title="Применить ко всем"
                                               @click="editProhibited ? '' : setOrderPredictionTimeToEachService()">
                                            <i class="fa fa-level-down"></i>ко всем
                                          </div>
                                          <fieldset class="value">
                                            <input type="text" placeholder="hh:mm" v-model="orderPredictionTime" v-mask="'##:##'">
                                          </fieldset>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="service-list" v-for="(serviceArray, serviceArrayIndex) in groupedServices">
                                      <div class="service-string" v-if="serviceArray[0].type == 'OrderToTrucking'"
                                           @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, serviceArrayIndex, 0, false)">
                                        <div class="item trucking-service-edit" title="Изменить">
                                          <span class="service-name">Грузоперевозки</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined ">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <span class="time">{{ getServiceTime(serviceArray[0]) }}</span>
                                          <span class="category">{{ serviceArray[0].category.name }}</span>
                                          <span class="duration">{{ formatServiceDuration(serviceArray[0]) }}ч.</span>
                                          <span class="payment-type"
                                                v-if="serviceArray[0].paymentType == 0">Часовая оплата</span>
                                          <span class="payment-type" v-if="serviceArray[0].paymentType == 1">Часовая оплата + километраж</span>
                                          <span class="quantity">x {{ serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'driver'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                      <div class="service-string"
                                           v-if="serviceArray[0].type == 'OrderToMover'"
                                           @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, serviceArrayIndex, 1, false)">
                                        <div class="item loader-service-edit" title="Изменить">
                                          <span class="service-name">Грузчики</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <span class="time">{{ getServiceTime(serviceArray[0]) }}</span>
                                          <span class="category">{{ serviceArray[0].category.name }}</span>
                                          <span class="duration">{{ formatServiceDuration(serviceArray[0]) }}ч.</span>
                                          <span class="quantity">x {{ serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'mover'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                      <div class="service-string"
                                           v-if="serviceArray[0].type == 'OrderToFurniture'"
                                           @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, serviceArrayIndex, 2, false)">
                                        <div class="item furniture-service-edit" title="Изменить">
                                          <span class="service-name">Сборка мебели</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <span class="time">{{ getServiceTime(serviceArray[0]) }}</span>
                                          <span class="duration">{{ formatServiceDuration(serviceArray[0]) }}ч.</span>
                                          <span class="quantity">x {{ serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'furniture'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                      <div class="service-string"
                                           v-if="serviceArray[0].type == 'OrderToPetrol'"
                                           @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, serviceArrayIndex, 3, false)">
                                        <div class="item gsm-service-edit" title="Изменить">
                                          <span class="service-name">ГСМ</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <span class="time">{{ getServiceTime(serviceArray[0]) }}</span>
                                          <span class="address">
                                                            <span v-for="(address, index) in serviceArray[0].addresses"
                                                                  v-if="index == 0 || index == serviceArray[0].addresses.length - 1">
                                                              {{ getSmallAddressFromFull(address)}}</span>
                                                    </span>
                                          <span class="distance">= {{ serviceArray[0].distance }}</span>
                                          <span class="quantity">x {{ serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'driver'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                      <div class="service-string"
                                           v-if="serviceArray[0].type == 'OrderToDowntime'"
                                           @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, serviceArrayIndex, 4, false)">
                                        <div class="item day-idle-service-edit" title="Изменить">
                                          <span class="service-name">Сутки простоя</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <span class="quantity">x {{ serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'driver'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                      <div class="service-string"
                                           v-if="serviceArray[0].type == 'OrderToGarbage'"
                                           @click="editProhibited ? '' : changeMainServiceWindowVisibility(true, serviceArrayIndex, 5, false)">
                                        <div class="item garbage-removal-service-edit" title="Изменить">
                                          <span class="service-name">Вывоз мусора</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <span class="time">{{ getServiceTime(serviceArray[0]) }}</span>
                                          <span class="category">{{ serviceArray[0].category.name }}</span>
                                          <span
                                            class="district">{{ serviceArray[0].garbageDisposalDistrict.name }} р-н</span>
                                          <span class="quantity">x {{ serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'driver'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="service-block">
                                    <div class="add-service">
                                      <label>Доп. услуги</label>
                                      <button type="button" class="add-dop-service"
                                              @click="editProhibited ? '' : changeAdditionalServiceWindowVisibility(true, null, true)">
                                        <i>+</i>Добавить
                                      </button>
                                    </div>
                                    <div class="service-list">
                                      <div class="service-string" v-for="(serviceArray, serviceArrayIndex) in groupedServices"
                                           v-if="serviceArray[0].type == 'OrderToAdditional' && !serviceArray[0].category.shippingPacking"
                                           @click="editProhibited ? '' : changeAdditionalServiceWindowVisibility(true, serviceArrayIndex, false)">
                                        <div class="item" title="Изменить">
                                          <span class="service-name">{{ serviceArray[0].category.name }}</span>
                                          <span class="summ" v-show="serviceIdCostMap.get(serviceArrayIndex) != undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                          <!-- Для доп.услуг типа "Упаковка" отображать количество упаковок -->
                                          <span class="quantity">x {{ serviceArray[0].category.packing ? serviceArray[0].itemCount : serviceArray.length }} шт.</span>
                                          <div class="admin-buttons">
                                            <span class="delete" title="Удалить"><img
                                              @click.stop="editProhibited ? '' : deleteService(serviceArrayIndex)"
                                              src="../image/cancel.svg"></span>
                                          </div>
                                        </div>
                                        <workers-block :serviceArrayFromOrder="serviceArray"
                                                       :serviceArrayIndex="serviceArrayIndex"
                                                       :order="order"
                                                       :editable="!editProhibited"
                                                       :needfulWorkerType="'driver'"
                                                       @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                      </div>
                                        <div class="service-string packaging">
                                        <label class="checkbox-label"><input type="checkbox"
                                                                             v-model="hasShippingPackingInServices"
                                                                             @click="addOrRemoveShippingPacking($event)"
                                                                              ><span
                                                class="service-name">Доставка упаковки</span>
                                            <span class="summ"
                                                  v-for="(serviceArray, serviceArrayIndex) in groupedServices"
                                                  v-if="serviceArray[0].type === 'OrderToAdditional' && serviceArray[0].category.shippingPacking"
                                                  @click="editProhibited ? '' : changeShippingPackingWindowVisibility(true, serviceArrayIndex)"
                                                  v-show="serviceIdCostMap.get(serviceArrayIndex) !== undefined">
                                            ({{ totalServicePrice(serviceArrayIndex, serviceArray[0].type) }})</span>
                                        </label>
                                            <div
                                                    v-for="(serviceArray, serviceArrayIndex) in groupedServices"
                                                    v-if="serviceArray[0].type === 'OrderToAdditional' && serviceArray[0].category.shippingPacking"
                                                    @click="editProhibited ? '' : changeShippingPackingWindowVisibility(true, serviceArrayIndex)">
                                          <div class="item" title="Изменить">
                                            <span class="time">{{ getServiceTime(serviceArray[0]) }}</span>
                                            <span class="address">
                                            <span>{{ getSmallAddressFromFull(serviceArray[0].address) }}</span>
                                          </span>
                                          </div>
                                          <workers-block :serviceArrayFromOrder="serviceArray"
                                                         :serviceArrayIndex="serviceArrayIndex"
                                                         :order="order"
                                                         :editable="!editProhibited"
                                                         :needfulWorkerType="'shippingPacking'"
                                                         @changeWorkerListWindowVisibility="changeWorkerListWindowVisibility"></workers-block>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                              <section class="request-sale section-open" ref="saleSection">
                                <div class="section-head" @click="openSaleSection(false)">Предоплата и акции
                                  <a href="request-sale" id="request-sale" class="anchor"></a>
                                </div>
                                <div class="section-body">
                                  <div class="payment-block">
                                    <div class="add-payment">
                                      <label>Предоплата</label>
                                      <button type="button" class="add-new-payment"
                                              @click="editProhibited ? '' : changePrepaymentWindowVisibility(true, null, true)">
                                        <i>+</i>Добавить
                                      </button>
                                    </div>
                                    <div class="payment-list" v-for="(prepayment, index) in order.prepayments">
                                      <div class="item edit-payment" title="Изменить"
                                           @click="editProhibited ? '' : changePrepaymentWindowVisibility(true, index, false)">
                                        <span class="date">{{ parseDate(prepayment.dateTime) }}</span>
                                        <span class="summ">{{ prepayment.amount }} руб.</span>
                                        <div class="admin-buttons">
                                          <span class="delete" title="Удалить"
                                                @click.stop="editProhibited ? '' : deletePrepayment(index)"><img
                                            src="../image/cancel.svg"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="sale-block">
                                    <div class="add-sale">
                                      <label class="checkbox-label">
                                        <input type="checkbox" v-model="flyerActive"><span>Акция</span>
                                      </label>
                                    </div>
                                    <div class="sale-block-content" v-show="!!flyerActive">
                                      <div class="fieldset sale-summ">
                                        <label class="fieldset-title">Сумма</label>
                                        <fieldset>
                                          <input type="number" min="0" v-model="order.flyerAmount">
                                        </fieldset>
                                        <span>руб.</span>
                                      </div>
                                      <div class="fieldset">
                                        <label class="fieldset-title">Комментарий к акции</label>
                                        <textarea placeholder="Комментарий" v-model="order.flyerDescription" />
                                      </div>
                                      <template v-if="!!order.brigadier && order.brigadier.brigadierId > 0">
                                        <label class="checkbox-label">
                                          <input type="checkbox" v-model="flyerConfirmed">Подтверждена
                                        </label>

                                        <div class="sales-list">
                                          <div class="service-string">
                                            <div class="fieldset">
                                              <label class="fieldset-title">Ответственный за акцию</label>
                                              <div class="workers-block">
                                                <div class="string">
                                                  <div class="worker visibility">
                                                    <div class="functional-buttons"><span title="Позвонить" class="call-button"><img src="../image/phone-call.svg"></span></div>
                                                    <span class="name">{{ order.brigadier.surname + ' ' + order.brigadier.name + ' ' + order.brigadier.patronymic }}</span>&nbsp;
                                                    <span class="brigadier">бригадир</span>&nbsp;
                                                    <span class="phone">{{ order.brigadier.phone }}</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                              </section>
                                <section class="request-comments" ref="commentSection">
                                    <div class="section-head" @click="openCommentSection(false)">Комментарии
                                        <a href="request-comments" id="request-comments" class="anchor"></a>
                                    </div>
                                    <div class="section-body">
                                        <div class="fieldset">
                                            <label class="fieldset-title">Комментарий к заказу</label>
                                            <textarea v-model="order.comment"></textarea>
                                        </div>
                                        <div class="fieldset">
                                            <label class="fieldset-title">Комментарий для рабочих</label>
                                            <textarea v-model="order.commentForWorkers"></textarea>
                                        </div>
                                        <div v-if="order.status === 2" class="fieldset reason-for-rejection">
                                            <a name="reason-for-rejection" id="reason-for-rejection"></a>
                                            <label class="fieldset-title obligatorily">Причина отклонения</label>
                                            <textarea ref="rejectReasonTextarea" v-model="order.rejectSeason"></textarea>
                                        </div>
                                    </div>
                                </section>
                            </div>
                          <div v-if="!editProhibited" class="request-footer visibility request-footer-view">
                                <button type="button" class="cancel-button" @click="cancel">Отмена</button>
                                <button type="button" class="save-button" id="order-save-button" @click="save">Сохранить</button>
                            </div>
                        </div>
                        <div class="request-sidebar">
                            <div class="request-report">
                                <section class="date-section" @click="openMainSection(true, true)">
                                    <div class="icon"><img src="../image/calendar.svg"></div>
                                    <span class="section-title">Дата и время</span>
                                    <div class="string">
                                        {{datetime}}
                                    </div>
                                </section>
                                <section class="client-section" @click="openClientSection(true, true)">
                                    <div class="icon"><img src="../image/client.svg"></div>
                                    <span class="section-title">Клиент</span>
                                    <div class="string">
                                        {{order.client.name}} <span class="firm" v-if="order.client.org">({{order.client.orgName}})</span>
                                        <a href="client-card.htm" target="_blank" class="to-client-card" title="Перейти в карточку клиента"><img src="../image/to-card.svg"></a>
                                    </div>
                                </section>
                                <section class="route-section" @click="openAddressSection(true, true)"
                                         v-if="displayAddresses && displayAddresses.length > 0">
                                    <div class="icon"><img src="../image/route.svg"></div>
                                    <span class="section-title">Адрес</span>
                                    <div class="address-list">
                                        <div v-for="(address, i) in displayAddresses" :key="i" class="address">
                                            {{address.displayPlace + (address.comment ? ', ' + address.comment : '')}}
                                        </div>
                                    </div>
                                    <div class="distance"><span>~</span> {{distance}} <span class="km">км</span></div>
                                </section>
                                <section class="items-section" @click="openItemsSection(true, true)">
                                    <div class="icon"><img src="../image/item.svg"></div>
                                    <span class="section-title">Услуги</span>
                                    <div class="items-list" v-for="category in serviceCategories">
                                    <div class="item"
                                         :class="{ packaging :category.shippingPacking }"
                                         v-if="category.count > 0">
                                      <template v-if="category.shippingPacking">
                                        Нужна доставка упаковки
                                      </template>
                                      <template v-else>
                                        {{ category.name }} <span class="numb" v-if="!category.shippingPacking">
                                              ({{ category.count }})</span>
                                      </template>
                                    </div>
                                  </div>
                                </section>
                                <section class="payment-section" @click="openMainSection(true, true)">
                                    <div class="icon"><img src="../image/payment.svg"></div>
                                    <span class="section-title">Способ оплаты</span>
                                    <div v-if="order.cash" class="string">{{!order.byCheck ? 'Наличный расчет' : 'Наличный расчет (чек)'}}</div>
                                    <div v-else class="string">
                                        Безналичный расчет
                                        <span class="prepayment-required" v-if="prepayRequiredAndNotExceedMinAmount">Необходима предоплата</span>
                                    </div>
                                </section>
                            </div>
                            <div class="request-total" @click="openSaleSection(true, true)">
                                <div class="string total">
                                    <span class="title">Итого:</span> {{ nominalCost }} <span class="rub">руб.</span>
                                </div>
                                <div class="string sale">
                                    <span class="title">Предоплата:</span> {{totalPrepayment}} <span class="rub">руб.</span>
                                </div>
                                <div class="string sale">
                                  <span class="title">Акция:</span> {{order.flyerAmount || 0}} <span class="rub">руб.</span>
                                </div>
                                <div class="string total-to-pay">
                                    <span class="title">К оплате:</span> {{resultPrice}} <span class="rub">руб.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import Constants from '@/constants.js'
  import AlertWindow from '@/components/AlertWindow.vue'
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import Address from '@/views/Address.vue'
  import Route from '@/views/Route.vue'
  import AdditionalService from '@/views/AdditionalService.vue'
  import MainService from '@/views/MainService.vue'
  import Prepayment from '@/views/Prepayment.vue'
  import draggable from 'vuedraggable'
  import DatePicker from 'vue2-datepicker'
  import Timepicker from 'vue2-timepicker'
  import api from '@/api'
  import moment from 'moment'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'
  import WorkerList from '@/views/WorkerList.vue'
  import ShippingPacking from '@/views/ShippingPacking.vue'
  import WorkersBlock from '@/views/WorkersBlock.vue'
  import AddressContactPerson from '@/views/AddressContactPerson.vue'

  function initialData() {
  return {
    id: 0,
    order: {
      datetime: new Date().getTime(),
      cash: null,
      client: {
        id: 0,
        phone: '',
        org: false
      },
      status: 0,
      services: [],
      prepayments: [],
      flyerStatus: null,
      flyerAmount: null,
      flyerDescription: null,
      distance: '',
      dateOfCreation: new Date().getTime(),
      authorName: '',
      prepaymentRequired: false,
      byCheck: false,
      clOrg: false,
      lastModified: new Date().getTime(),
      predictionTime: null
    },
    initialOrderDateTime: new Date().getTime(),
    initialStatus: 0,
    clients: [],
    manualDistanceVal: null,
    isAdditionalServiceWindowVisible: false,
    serviceIndex: null,
    mainServiceNr: null,
    isMainServiceWindowVisible: false,
    addingNewService: false,
    hasShippingPackingInServices: null,
    isPrepaymentWindowVisible: false,
    isWorkerListWindowVisible: false,
    prepaymentIndex: null,
    addingNewPrepayment: false,
    needfulWorkerType: null,
    serviceArrayForWorkerList: null,
    serviceArrayIndexForWorkerList: null,
    categoryNameForWorkerList: null,
    categoryIdForWorkerList: null,
    isShippingPackingWindowVisible: false,
    showOrderTimes: false,
    serviceIdCostMap: new Map(),
    lastClientPhoneRequested: 0
  }
}

/** Данные, которые не должны обновляться при переходе от /orders/new к /orders/{id} */
function initialSettingsData() {
  return {
    nightRate: null,
    minBalanceToAcceptOffer: null
  }
}

export default {
  name: 'Order',
  components: {
    AlertWindow,
    MenuDispatcher,
    HeaderDispatcher,
    Address,
    Route,
    draggable,
    DatePicker,
    Timepicker,
    AdditionalService,
    MainService,
    Prepayment,
    WorkerList,
    ShippingPacking,
    WorkersBlock,
    AddressContactPerson
  },

  directives: { mask },

  data () {
    let data = {};
    Object.assign(data, initialData());
    Object.assign(data, initialSettingsData());

    return data;
  },
  computed: {
    serviceCategories() {
      let resultCategoriesArray = [];
      let tmpSet = new Set();

      let getCategoryId = (category) => `${category.className}-${category.id}`;

      for (let serviceArray of this.groupedServices) {
        let service = serviceArray[0];
        let categoryId = getCategoryId(service.category);

        if (!tmpSet.has(categoryId)) {
          tmpSet.add(categoryId);

          let serviceCount;
          if (!!service.category.packing) {
            serviceCount = service.itemCount || 0;
          } else {
            serviceCount = this.groupedServices
                .filter(gs => getCategoryId(gs[0].category) == categoryId)
                .map(gs => gs.length)
                .reduce((len1, len2) => len1 + len2, 0);
          }

          resultCategoriesArray.push({
            name: service.category.name,
            count: serviceCount,
            shippingPacking: service.category.shippingPacking
          });
        }
      }

      return resultCategoriesArray;
    },

    waitingApiRequestsCount () {
      return this.$store.getters.waitingApiRequestsCount
    },

    orderName () {
      if (this.order.id > 0) {
        return `Заявка №${this.order.id}`
      } else {
        return 'Новая заявка'
      }
    },
    addresses: {
      get () {
        return this.$store.getters.addresses
      },
      set (addresses) {
        this.$store.commit('updateAddresses', addresses)
      }
    },
    validAddresses() {
      return this.$store.getters.validAddresses;
    },
    displayAddresses: {
      get () {
        return this.validAddresses
          .map(address => {
            return Object.assign(address, {
              displayPlace: utils.getSmallAddressFromFull(address.place, 3)
            })
          })
      }
    },
    date: {
      get () {
        let datetime = this.order.datetime
        if (datetime) {
          return new Date(datetime)
        } else {
          return new Date()
        }
      },
      set (date) {
        let timestamp = date.getTime()
        this.order.datetime = timestamp
      }
    },
    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.order.datetime)
      },
      set (time) {
        if (time.length == 5) {
          let date = new Date(this.order.datetime)
          date.setHours(0, 0, 0, 0)
          let newDateValue = date.getTime() + utils.getLongFromFormattedTimeString(time);
          this.order.datetime = newDateValue;

          this.groupedServices.forEach(gs => {
            gs.forEach(s => {
              s.date = newDateValue;
            })
          });

          if (this.allAppointedWorkers.length !== 0) {
            alert('Все рабочие будут сброшены');
            this.groupedServices.forEach(gs => {
              gs.forEach(s => {
                s.worker = null;
              })
            })

          }
        }
      }
    },
    datetime () {
      let months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      let year = this.date.getFullYear()
      let month = this.date.getMonth()
      let day = this.date.getDate()
      let hour = this.date.getHours()
      let min = this.date.getMinutes()
      return `${day.toString().padStart(2, '0')} ${
        months[month]
      } ${year} ${hour.toString().padStart(2, '0')}:${min
        .toString()
        .padStart(2, '0')}`
    },
    autoDistance: {
      get () {
        return this.$store.state.distance
      }
    },
    manualDistance: {
      get () {
        return this.manualDistanceVal
      },
      set (manualDistance) {
        if (manualDistance !== '' && manualDistance < 0) {
          alert('Пожалуйста, введите расстояние больше 0')
        } else if (manualDistance !== '') {
          this.manualDistanceVal = manualDistance
          this.order.distance = manualDistance
        } else {
          this.manualDistanceVal = manualDistance
          this.order.distance = this.autoDistance
        }
      }
    },
    distance () {
      if (this.manualDistance !== '' && this.manualDistance != null) {
        return this.manualDistance
      } else {
        return this.autoDistance
      }
    },

    nominalCost() {
      return Math.round(this.calculateSummaryServicePrice() * 100) / 100;
    },

    statusClass () {
      if (this.order.status === 0 || this.order.status === null) {
        return 'green-status'
      } else if (this.order.status === 1) {
        return 'yellow-status'
      } else if (this.order.status === 2) {
        return 'red-status'
      } else if (this.order.status === 3) {
        return 'light-blue-status'
      } else if (this.order.status === 4) {
        return 'rose-status'
      } else if (this.order.status === 5) {
        return 'blue-status'
      } else if (this.order.status === 6) {
        return 'orange-status'
      } else if (this.order.status === 7) {
        return 'violet-status'
      } else if (this.order.status === 8) {
        return 'brown-status'
      }
    },
    statusText () {
      if (this.order.status === 0 || this.order.status === null) {
        return 'Принята'
      } else if (this.order.status === 1) {
        return 'Ожидает'
      } else if (this.order.status === 2) {
        return 'Отклонена'
      } else if (this.order.status === 3) {
        return 'Распределена'
      } else if (this.order.status === 4) {
        return 'Подтвердить оплату'
      } else if (this.order.status === 5) {
        return 'Завершена'
      } else if (this.order.status === 6) {
          return 'Рабочие подтверждены'
      } else if (this.order.status === 7) {
          return 'Начали'
      } else if (this.order.status === 8) {
          return 'Прогноз получен'
      }
    },
    canCompleteOrder () {
      //Не суперадмин может подтвердить оплату только в промежутке от сегодняшего дня до трех дней ранее
      let orderAllowCompleteStartDate = (utils.getDateWithoutTime(new Date()))
      orderAllowCompleteStartDate.setDate(orderAllowCompleteStartDate.getDate() - 3)
      let orderAllowCompleteEndDate = (utils.getDateWithoutTime(new Date()))
      orderAllowCompleteEndDate.setDate(orderAllowCompleteEndDate.getDate() + 1)

      return this.order.id > 0
          && this.order.status === 4
          && (utils.checkRole(this.$store.getters.roleCode, ['ROLE_SUPER_ADMIN']) || (orderAllowCompleteStartDate.getTime() <= this.initialOrderDateTime && this.initialOrderDateTime < orderAllowCompleteEndDate.getTime()))
    },

    groupedServices: {
      get () {
        let sortedGroupedServices = this.$store.getters.groupedServices
        sortedGroupedServices = sortedGroupedServices.sort((service1, service2) => {
          // "Нужна доставка упаковки" всегда в конце списка
          return service1[0].category.shippingPacking > service2[0].category.shippingPacking
        })
        return sortedGroupedServices
      }
    },

    startServicesTime () {
      let minValue = null
      this.groupedServices.forEach(gs => {
        gs
          .filter(s => s.realStartTime != null)
          .forEach(s => {
            if (s.realStartTime < minValue || minValue == null) { minValue = s.realStartTime }
          })
      })
      return minValue
    },

    endServicesTime () {
      let maxValue = null
      this.groupedServices.forEach(gs => {
        gs
          .filter(s => s.realEndTime != null)
          .forEach(s => {
            if (s.realEndTime > maxValue || maxValue == null) { maxValue = s.realEndTime }
          })
      })
      return maxValue
    },

    orderRealStartTime: {
      get () {
        if (this.order.realStartTime == null || moment(this.order.realStartTime).isAfter(this.startServicesTime)) { this.order.realStartTime = this.startServicesTime }

        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.order.realStartTime)
      },

      set (time) {
        if (time.length === 5) {
          let date = new Date(this.order.datetime)
          date.setHours(0, 0, 0, 0)
          this.order.realStartTime = date.getTime() + utils.getLongFromFormattedTimeString(time)
          if (this.startServicesTime != null && moment(this.order.realStartTime).isAfter(moment(this.startServicesTime))) {
            this.order.realStartTime = this.startServicesTime
            this.$refs.alertWindow.show('Ошибка', 'Невозможно указать дату начала позже, чем начало какой-либо из услуг')
          }
        }
      }
    },

    orderRealEndTime: {
      get () {
        if (this.order.realEndTime == null || moment(this.order.realEndTime).isBefore(this.endServicesTime)) { this.order.realEndTime = this.endServicesTime }

        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.order.realEndTime)
      },

      set (time) {
        if (time.length === 5) {
          let date = new Date(this.order.datetime)
          date.setHours(0, 0, 0, 0)
          let orderRealEndTime = date.getTime() + utils.getLongFromFormattedTimeString(time)

          // чтобы время окончания всех услуг не было позже времени начала всех услуг или начала всей заявки
          if ((this.order.realStartTime && orderRealEndTime < this.order.realStartTime) ||
            (!this.order.realStartTime && orderRealEndTime < this.order.datetime))
            orderRealEndTime += 24 * 60 * 60 * 1000;

          this.order.realEndTime = orderRealEndTime;
          if (this.endServicesTime != null && moment(this.order.realEndTime).isBefore(moment(this.endServicesTime))) {
            this.order.realEndTime = this.endServicesTime
            this.$refs.alertWindow.show('Ошибка', 'Невозможно указать дату окончания раньше, чем окончание какой-либо из услуг')
          }
        }
      }
    },

    orderPredictionTime: {
      get() {
        return utils.getTimeStringFromLong(this.order.predictionTime);
      },

      set(time) {
        if (time.length === 5) {
          this.order.predictionTime = utils.getLongFromFormattedDurationString(time);
        }
      }
    },

    orderDuration: {
      get () {
        return utils.formatOrderDuration(this.order)
      }
    },

    phones: {
      get () {
        return this.clients.map(client => {
          return `${client.phone} (${client.name !== '' ? client.name : 'Имя отсутствует'})`
        })
      }
    },

    phonesListStyle: {
      get () {
        let style = 'display: none'
        if (this.clients && this.clients.length > 0 &&
          (this.clients.length > 1
              || !this.order.client.id
              || this.clients[0].phone !== this.order.client.phone.replace(/\s/g, '').replace('(', '').replace(')', '').replace(/-/g, ''))) {
          style = 'display: block'
        }
        return style
      }
    },

    totalPrepayment: {
      get () {
        let summaryAmount = 0
        this.order.prepayments.forEach(p => {
          summaryAmount += Number(p.amount)
        })
        return summaryAmount
      }
    },

    resultPrice: {
      get () {
        let resultPrice = this.nominalCost - this.totalPrepayment - (this.order.flyerAmount || 0)
        if (resultPrice < 0) { resultPrice = 0 }
        return resultPrice
      }
    },

    prepayRequiredAndNotExceedMinAmount: {
      get () {
        return this.order.prepaymentRequired && this.totalPrepayment < Constants.MIN_PREPAYMENT_AMOUNT
      }
    },

    allAppointedWorkers: {
      get () {
        return this.$store.getters.allAppointedWorkers
      }
    },

    flyerActive: {
      get() {
        return !!this.order.flyerStatus && this.order.flyerStatus != 'none';
      },

      set(val) {
        if (!!val) {
          this.order.flyerStatus = 'active';
        } else {
          this.order.flyerStatus = 'none';
        }
      }
    },

    flyerConfirmed: {
      get() {
        return !!this.order.flyerStatus && this.order.flyerStatus == 'confirmed';
      },

      set(val) {
        if (!!val) {
          this.order.flyerStatus = 'confirmed';
        } else {
          this.order.flyerStatus = 'active';
        }
      }
    },

    editProhibited () {
      return utils.checkRole(this.$store.getters.roleCode, ['ROLE_HR'])
          || (this.order.status == 5 && !utils.checkRole(this.$store.getters.roleCode, ['ROLE_BOOKER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']));
    }
  },

  watch: {
    'order.client.phone' (phone) {
      if (phone && phone.indexOf('+7') >= 0) {
        let unmaskedPhone = phone.replace(/\s/g, '').replace('(', '').replace(')', '').replace(/-/g, '');
        if (unmaskedPhone.length > 5) { // +7(xxx)y - начинаем поиск с y
          this.lastClientPhoneRequested = unmaskedPhone;
          api.getClientByPhone(unmaskedPhone)
              .then(clientData => {
                if (clientData.phoneRequested == this.lastClientPhoneRequested) {
                  this.clients = clientData.clients;
                }
              });
        }
      } else {
        this.clients = []
      }
    },

    validAddresses: {
      handler: function(addresses) {
        this.$store.dispatch('calculateDistance')
            .then(distance => {
              if (this.manualDistance === null || this.manualDistance === '') {
                this.order.distance = distance
              }
            });
      },
      deep: true
    },

    'autoDistance' (distance) {
      this.manualDistance = distance
    },

    'order.byCheck' () {
      this.calculateSummaryServicePrice()
    }
  },

  beforeRouteUpdate (to, from, next) {
    Object.assign(this.$data, initialData())
    this.getOrder(to.params.id)
    next()
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('request-page');

    // отключение редактирования данных для пользователя с ролью бухгалтера или кадровика
    if (this.editProhibited) {
      let nodes = this.$refs.rootDiv.getElementsByTagName('*');
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].disabled = true
      }
    }

    this.addDatePickerWatcher();

    Promise.all(
        [api
            .getMoverCategories()
            .then(moverCategories => {
              this.$store.commit('updateMoverCategories', moverCategories)
            }),
        api
            .getAdditionalCategories()
            .then(additionalCategories => {
              this.$store.commit('updateAdditionalCategories', additionalCategories)
            }),
        api
            .getRegions()
            .then(regions => {
              this.$store.commit('updateRegions', regions)
            }),
        api
            .getDistricts()
            .then(districts => {
              this.$store.commit('updateDistricts', districts)
            }),
        api
            .getWorkSettingByCode('night_rate')
            .then(data => {
              if (data && data.value) {
                this.nightRate = Number(data.value)
              } else {
                this.nightRate = 0
              }
            }),
        api
            .getWorkSettingByCode('min_balance_to_accept_offer')
            .then(data => {
              if (data && data.value) {
                this.minBalanceToAcceptOffer = Number(data.value)
              } else {
                this.minBalanceToAcceptOffer = 0
              }
            })]
    ).then(() => {
      this.id = this.$route.params.id;
      this.getOrder(this.id);
      this.order.prepayments = this.$store.getters.prepayments;
    })
  },

  methods: {
    openCommentSectionIfCommentsAreNotNull() {
      if (this.order.comment !== null || this.order.commentForWorkers !== null) {
        this.openCommentSection(true, false)
      }
    },
    getOrder (id) {
      if (id !== 'new') {
        api.getOrderById(id).then(async order => {
          if (order) {
            await this.$store.dispatch('updateAddresses', []);
            await this.$store.commit('updateGroupedServices', []);
            await this.$store.commit('updatePrepayments', []);

            this.order = order
            if (!this.order.status)
              this.order.status = 0
            this.initialStatus = this.order.status
            this.initialOrderDateTime = this.order.datetime

            Object.assign(this.order.client, {
              name: order.clientName,
              phone: order.clientPhone,
              email: order.clientEmail,
              orgName: order.clientOrgName,
              orgInn: order.clientOrgInn,
              orgKpp: order.clientOrgKpp,
              orgAddress: order.clientOrgAddress,
              org: order.clientOrg
            });

            if (this.order.distance !== 0) { this.manualDistance = this.order.distance }
            this.order.services.forEach(s => {
              if (s.worker.id === 0) { s.worker = null }
            })
            this.$store.commit('updateGroupedServices',
              this.groupArrayBy(this.order.services, item => [item.type, item.date, item.clientTime, item.category.id, item.inKzn]))
            this.$store.commit('updatePrepayments', this.order.prepayments)
            this.hasShippingPackingInServices = this.checkHasShippingPackingInServices(this.groupedServices)
            if (this.order.addresses.length > 0) {
              this.$store.dispatch('updateAddresses', this.order.addresses)
                .then(() => {
                  // сохранение значения дистанции заявки, чтобы после пересчета яндекса вернуть его в поле "Расстояние"
                  let tmpOrderDistance;
                  if (this.order.distance && this.order.distance > 0)
                    tmpOrderDistance = this.order.distance;

                  this.$store.dispatch('calculateDistance')
                    .then(() => {
                      this.manualDistance = tmpOrderDistance ? tmpOrderDistance : this.order.distance;
                    })
                })
                  .then(() => { if (this.order.status === 5) this.calculateSummaryServicePrice() })
                  .then(() => {this.openCommentSectionIfCommentsAreNotNull()})
            }
          } else { this.initNewOrder() }
        })
      } else { this.initNewOrder() }
    },
    initNewOrder () {
      this.$store.commit('updateAddresses', [utils.getDefaultAddress()])
      this.$store.commit('updateGroupedServices', [])
      this.$store.commit('updatePrepayments', [])
      this.order.cash = true;
      this.order.addresses = this.addresses
      this.order.authorName = this.$store.getters.username
      this.$store.commit('setDistance', 0)
      this.serviceIdCostMap = new Map()
      this.$store.commit('clearGroupedServicesPromises')
      this.initialStatus = 0
    },
    choosePhone (i) {
      this.order.client = this.clients[i]
      this.clients = this.clients.filter(client => client.phone.indexOf(this.order.client.phone) > -1)
    },

    setNullClientPhone () {
      this.order.client.id = null
    },

    addAddress () {
      let newAddress = utils.getDefaultAddress();
      let addresses = this.addresses;
      addresses.push(newAddress);
      this.$store.dispatch('updateAddresses', addresses);
    },
    changePaymentType (cash) {
      if (this.editProhibited || this.order.cash == null)
        return;

      if (cash === true || cash === false) {
        this.order.cash = cash
      } else {
        this.order.cash = !this.order.cash
      }

      if (this.order.cash === true) {
        for (let gsIndex in this.groupedServices) {
          if (this.groupedServices.hasOwnProperty(gsIndex)) {
            for (let s of this.groupedServices[gsIndex]) {
              if (s.worker && s.worker.balance < this.minBalanceToAcceptOffer) {
                this.$store.dispatch('deleteWorkerFromServiceByIndex', {
                  index: gsIndex,
                  workerId: s.worker.id
                })
              }
            }
          }
        }
      }
      this.calculateSummaryServicePrice()
    },
    openSection (section, open, scrollIntoView) {
      if (open) {
        section.classList.add('section-open')
      } else {
        section.classList.toggle('section-open')
      }
      if (scrollIntoView) {
        section.scrollIntoView()
      }
    },
    openMainSection (open, scrollIntoView) {
      this.openSection(this.$refs.mainSection, open, scrollIntoView)
    },
    openClientSection (open, scrollIntoView) {
      this.openSection(this.$refs.clientSection, open, scrollIntoView)
    },
    openAddressSection (open, scrollIntoView) {
      this.openSection(this.$refs.addressSection, open, scrollIntoView)
    },
    openItemsSection (open, scrollIntoView) {
      this.openSection(this.$refs.itemsSection, open, scrollIntoView)
    },
    openSaleSection (open, scrollIntoView) {
      this.openSection(this.$refs.saleSection, open, scrollIntoView)
    },
    openCommentSection (open, scrollIntoView) {
      this.openSection(this.$refs.commentSection, open, scrollIntoView)
    },
    openStatusMenu () {
      if (this.order.status != 5 && this.order.status != 4) {
        this.$refs.statusList.classList.toggle('request-list-open')
      }
    },

      scrollToRejectReasonTextArea() {
          this.openCommentSection(true, true)
          this.$nextTick(() => {
              this.$refs.rejectReasonTextarea.scrollIntoView()
              this.$refs.rejectReasonTextarea.focus()
          })
      },

    choseStatus (status) {
      this.order.status = status
        if (this.order.status === 2)
            this.scrollToRejectReasonTextArea();
    },

    save () {
      if (this.$store.getters.waitingApiRequestsCount != 0) { return }

      if (this.order.cash !== false && this.order.cash !== true) { return }

      if (this.$store.getters.groupedServicesPromises) {
        document.getElementById('order-save-button').disabled = true
        Promise.all(this.$store.getters.groupedServicesPromises).then(() => {
          let groupedServices = this.groupedServices

          if (this.order.client.id === 0) {
            if (!this.order.client.phone) {
              this.$refs.alertWindow.show('Ошибка сохранения', 'Заполните телефон нового клиента')
              return
            }
          }
          if (this.errors.first('email')) {
            this.$refs.alertWindow.show('Ошибка сохранения', 'Введенный почетовый адрес клиента некорректен')
            return
          }
          if (this.order.status === 2 && !this.order.rejectSeason) {
            this.$refs.alertWindow.show('Ошибка сохранения', 'Укажите причину отклонения заявки')
              this.scrollToRejectReasonTextArea();
            return
          }

          for (let a of this.addresses) {
            if (!a.lat || !a.lng) {
              this.$refs.alertWindow.show('Ошибка сохранения', 'Заполните адрес!')
              return
            }
          }

          this.order.addresses = this.addresses.map((item, i) => {
            item.id = 0
            item.orderNum = i
            return item
          })

          this.order.nominalCost = this.nominalCost

          this.order.services = []
          groupedServices.forEach(gs => {
            gs.forEach(s => {
              this.order.services.push(s)
            })
          })

          for (let gs of groupedServices) {
            for (let s of gs) {
              if (
                (s.type == 'OrderToMover' ||
                    s.type == 'OrderToFurniture' ||
                    s.type == 'OrderToTrucking' ||
                    s.type == 'OrderToGarbage' ||
                    s.type == 'OrderToPetrol' ||
                    (s.type == 'OrderToAdditional' && s.category.shippingPacking)) &&
                  (
                    (s.addresses !== undefined && s.addresses.length === 0) ||
                    (s.address !== undefined && s.address == null)
                  )
              ) {
                this.$refs.alertWindow.show('Ошибка сохранения', 'В заявке есть услуги без добавленных адресов')
                return
              }
            }
          }

          api
            .saveOrder(this.order)
            .then((orderId) => {
              this.id = this.$route.params.id
              this.$router.push('/orders/' + orderId)
                if(this.order.status === 5 && utils.checkRole(this.$store.getters.roleCode, ['ROLE_BOOKER', 'ROLE_ADMIN']))
                  this.$refs.alertWindow.show('Сохранено', 'Поле "комментарий к заказу" сохранено.')
                else
                  this.$refs.alertWindow.show('Сохранено', 'Изменения успешно сохранены')

                if (this.id !== 0) { this.getOrder(orderId) }
            })
            .catch(err => alert(err))
        }).finally(() => document.getElementById('order-save-button')
          ? document.getElementById('order-save-button').disabled = false : null)
      } else {
        document.getElementById('order-save-button').disabled = false
      }
    },
    cancel () {
      this.$router.go(-1)
    },

    groupArrayBy (array, func) {
      let groups = {}
      array.forEach(o => {
        let group = JSON.stringify(func(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })

      return Object
        .keys(groups)
        .map(group => groups[group])
    },

    parseDate (date) {
      return moment(date).format('DD.MM.YYYY')
    },

    formatServiceDuration (service) {
      return moment(new Date().getTimezoneOffset() * 60000 + service.clientTime).format('HH:mm')
    },

    getServiceTime (service) {
      return service.date != null
        ? moment(service.date).format('HH:mm')
        : ''
    },

    changeAdditionalServiceWindowVisibility (value, serviceIndex, isNewService) {
      this.isAdditionalServiceWindowVisible = value
      this.serviceIndex = serviceIndex
      this.addingNewService = isNewService
      utils.changeShadowVisibility(value)
    },

    changePrepaymentWindowVisibility (value, prepaymentIndex, isNewPrepayment) {
      this.isPrepaymentWindowVisible = value
      this.prepaymentIndex = prepaymentIndex
      this.addingNewPrepayment = isNewPrepayment
      utils.changeShadowVisibility(value)
      if (!value) { this.order.prepayments = this.$store.state.prepayments }
    },

    changeMainServiceWindowVisibility (value, serviceIndex, mainServiceNr, isNewService) {
      this.isMainServiceWindowVisible = value
      this.serviceIndex = serviceIndex
      this.mainServiceNr = mainServiceNr
      this.addingNewService = isNewService
      utils.changeShadowVisibility(value)
    },

    changeShippingPackingWindowVisibility (value, serviceIndex) {
      this.isShippingPackingWindowVisible = value
      this.serviceIndex = serviceIndex
      utils.changeShadowVisibility(value)
    },

    deleteService (index) {
      this.$store.commit('deleteGroupedServiceByIndex', index)
    },

    deletePrepayment (index) {
      this.$store.commit('deletePrepaymentByIndex', index)
    },

    calculateSummaryServicePrice() {
      let summaryPrice = 0;

      this.groupedServices.forEach(gs => {
        let gsPrice = {
          servicePrice: 0.00,
          components: {
            mainPrice: 0.00,
            regionSurchargePrice: 0.00,
            distanceSurchargePrice: 0.00,
            nightRatePrice: 0.00,
            categoryClientSurchargePrice: 0.00,
            additionDayPrice: 0.00,
            garbageDisposalDistrictPrice: 0.00,
            categoryMinPriceTaken: false,
          }
        };

        gs.forEach(s => {
          let servicePrice = 0;

          let mainPrice;
          let regionSurchargePrice;
          let distanceSurchargePrice;
          let nightRatePrice;
          let categoryClientSurchargePrice;
          let additionDayPrice;
          let garbageDisposalDistrictPrice;
          let categoryMinPriceTaken;

          let fullServiceDuration;
          let minimalServiceDuration;
          let resultDuration;
          let surchargeByRegionInHours = 0;

          if (s.type === 'OrderToTrucking') {
            let kmPriceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.kmPriceSurchargeByCashless;
            let hourPriceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.hourPriceSurchargeByCashless;

            fullServiceDuration = utils.calculateServiceDuration(s);
            minimalServiceDuration = s.category.minDuration * 1000 * 60 * 60;
            if (fullServiceDuration < minimalServiceDuration)
              fullServiceDuration = minimalServiceDuration;

            fullServiceDuration = utils.mapMsToTimeObject(fullServiceDuration);

            resultDuration = Math.trunc(
              fullServiceDuration.minutes >= 11 ?
                fullServiceDuration.hours + 1 :
                fullServiceDuration.hours);

            nightRatePrice = this.nightRate * utils.calculateNightHours(s);

            surchargeByRegionInHours = utils.spotOrderSurchargeByRegionInHours(s.addresses, this.$store.getters.regions, true, false, false);

            mainPrice = (s.category.hourPrice + hourPriceSurchargeByCashless) * resultDuration; // отображать
            regionSurchargePrice = (s.category.hourPrice + hourPriceSurchargeByCashless) * surchargeByRegionInHours; // отображать

            servicePrice += mainPrice;
            servicePrice += regionSurchargePrice;

            if (s.paymentType === 1) {
              distanceSurchargePrice = (s.category.kmPrice + kmPriceSurchargeByCashless) * s.distance; // отображать
              servicePrice += distanceSurchargePrice;
            }

            servicePrice += nightRatePrice; // отображать

            summaryPrice += servicePrice;
          }

          if (s.type == 'OrderToMover') {
            let priceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceSurchargeByCashless;
            // Надбавка за проезд в ночное время по заявке по безналу
            let clientPriceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.clientPriceSurchargeByCashless;


              fullServiceDuration = utils.calculateServiceDuration(s);
            minimalServiceDuration = s.category.minDuration * 1000 * 60 * 60;
            if (fullServiceDuration < minimalServiceDuration)
              fullServiceDuration = minimalServiceDuration;

            fullServiceDuration = utils.mapMsToTimeObject(fullServiceDuration);

            resultDuration = Math.trunc(
              fullServiceDuration.minutes >= 11 ?
                fullServiceDuration.hours + 1 :
                fullServiceDuration.hours);



              nightRatePrice = this.nightRate;

              // Надбавка за проезд в ночное время
              categoryClientSurchargePrice = utils.calculateNightHours(s) > 0 ?
                  ((s.category.clientSurcharge > 0 ? s.category.clientSurcharge : nightRatePrice) + clientPriceSurchargeByCashless)
                  : 0; // отображать

            surchargeByRegionInHours = utils.spotOrderSurchargeByRegionInHours(s.addresses, this.$store.getters.regions, false, true, false);

            mainPrice = (s.category.price + priceSurchargeByCashless) * resultDuration; // отображать
            regionSurchargePrice = (s.category.price + priceSurchargeByCashless) * surchargeByRegionInHours; // отображать

            servicePrice += mainPrice;
            servicePrice += regionSurchargePrice;
            servicePrice += categoryClientSurchargePrice;

            summaryPrice += servicePrice;
          }

          if (s.type === 'OrderToFurniture') {
            let priceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceSurchargeByCashless;
            // Надбавка за проезд в ночное время по заявке по безналу
            let clientPriceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.clientPriceSurchargeByCashless;


              fullServiceDuration = utils.calculateServiceDuration(s);
            minimalServiceDuration = s.category.minDuration * 1000 * 60 * 60;
            if (fullServiceDuration < minimalServiceDuration)
              fullServiceDuration = minimalServiceDuration;

            fullServiceDuration = utils.mapMsToTimeObject(fullServiceDuration);

            resultDuration = Math.trunc(
              fullServiceDuration.minutes >= 11 ?
                fullServiceDuration.hours + 1 :
                fullServiceDuration.hours);

            let calculatedNightHours = utils.calculateNightHours(s);

            nightRatePrice = this.nightRate;

              // Надбавка за проезд в ночное время в заявке с безналичной оплатой
              categoryClientSurchargePrice = calculatedNightHours > 0 ?
                  ((s.category.clientSurcharge > 0 ? s.category.clientSurcharge : nightRatePrice) + clientPriceSurchargeByCashless)
                  : 0;


            surchargeByRegionInHours = utils.spotOrderSurchargeByRegionInHours(s.addresses, this.$store.getters.regions, false, false, true);

            mainPrice = (s.category.price + priceSurchargeByCashless) * resultDuration; // отображать
            regionSurchargePrice = (s.category.price + priceSurchargeByCashless) * surchargeByRegionInHours; // отображать

            servicePrice += mainPrice;
            servicePrice += regionSurchargePrice;
            servicePrice += categoryClientSurchargePrice;

            summaryPrice += servicePrice;
          }

          if (s.type === 'OrderToPetrol') {
            let priceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceSurchargeByCashless;
            let minPriceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.minPriceSurchargeByCashless;
            let categoryMinPrice = s.category.minPrice + minPriceSurchargeByCashless;

            servicePrice = (s.category.price + priceSurchargeByCashless) * s.distance;

            if (servicePrice < categoryMinPrice) {
              categoryMinPriceTaken = true;
              servicePrice = categoryMinPrice;
            }

            summaryPrice += servicePrice;
          }

          if (s.type === 'OrderToDowntime') {
            let priceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceSurchargeByCashless;
            let priceKznSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceKznSurchargeByCashless;

            if (s.inKzn)
              servicePrice = s.category.priceKzn + priceKznSurchargeByCashless;
            else
              servicePrice = s.category.price + priceSurchargeByCashless;

            summaryPrice += servicePrice;
          }

          if (s.type === 'OrderToGarbage') {
            let priceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceSurchargeByCashless;
            let additionalDayCount = s.dayCount - 1;

            mainPrice = s.category.price + priceSurchargeByCashless;
            additionDayPrice = (s.category.addPrice + priceSurchargeByCashless) * additionalDayCount;
            garbageDisposalDistrictPrice = s.garbageDisposalDistrict.surcharge;

            servicePrice += mainPrice;
            servicePrice += additionDayPrice;
            servicePrice += garbageDisposalDistrictPrice;

            summaryPrice += servicePrice;
          }

          if (s.type === 'OrderToAdditional') {
            let priceSurchargeByCashless = this.order.cash && !this.order.byCheck ? 0 : s.category.priceSurchargeByCashless;

            servicePrice = s.category.price + priceSurchargeByCashless;
            if (!!s.category.packing)
              servicePrice *= (s.itemCount || 1);

            summaryPrice += servicePrice;
          }

          s.surchargeByRegionInHours = surchargeByRegionInHours;

          Object.assign(gsPrice, {
            servicePrice: gsPrice.servicePrice + servicePrice,
          });
          Object.assign(gsPrice.components, {
            mainPrice: gsPrice.components.mainPrice + (mainPrice || 0),
            // Надбавка за проезд между регионами
            regionSurchargePrice: gsPrice.components.regionSurchargePrice + (regionSurchargePrice || 0),
            // Надбавка за километраж
            distanceSurchargePrice: gsPrice.components.distanceSurchargePrice + (distanceSurchargePrice || 0),
            // Надбавка за ночной тариф
            nightRatePrice: gsPrice.components.nightRatePrice + (nightRatePrice || 0),
            // Надбавка за проезд в ночное время в заявке с безналичной оплатой
            categoryClientSurchargePrice: gsPrice.components.categoryClientSurchargePrice + (categoryClientSurchargePrice || 0),
            // Надбавка за доп.дни вывоза мусора
            additionDayPrice: gsPrice.components.additionDayPrice + (additionDayPrice || 0),
            // Надбавка за район вывоза мусора
            garbageDisposalDistrictPrice: gsPrice.components.garbageDisposalDistrictPrice + (garbageDisposalDistrictPrice || 0),
            // Взята минимальная стоимость из справочника
            categoryMinPriceTaken: categoryMinPriceTaken
          });
        });

        let gsIndex = this.groupedServices.indexOf(gs);
        this.serviceIdCostMap.set(gsIndex, gsPrice);
      });

      return summaryPrice;
    },

    totalServicePrice(serviceArrayIndex, type) {
      let gsPrice = this.serviceIdCostMap.get(serviceArrayIndex);
      if (gsPrice == undefined)
        return undefined;

      let priceSummary = gsPrice.servicePrice + ' руб.';
      switch (type) {
        case 'OrderToTrucking':
          if (gsPrice.components.regionSurchargePrice
            || gsPrice.components.distanceSurchargePrice
            || gsPrice.components.nightRatePrice) {
            priceSummary += ': ';
            priceSummary += [
              gsPrice.components.mainPrice ? 'основная - ' + gsPrice.components.mainPrice + ' руб.' : '',
              gsPrice.components.regionSurchargePrice ? 'надбавка за регионы - ' + gsPrice.components.regionSurchargePrice + ' руб.' : '',
              gsPrice.components.distanceSurchargePrice ? 'надбавка за километраж - ' + gsPrice.components.distanceSurchargePrice + ' руб.' : '',
              gsPrice.components.nightRate ? 'ночной тариф - ' + gsPrice.components.nightRate + ' руб.' : ''
            ].filter(priceComponent => priceComponent).join(', ');
          }
          break;
        case 'OrderToMover':
          if (gsPrice.components.regionSurchargePrice
            || gsPrice.components.categoryClientSurchargePrice
              || gsPrice.components.nightRatePrice) {
            priceSummary += ': ';
            priceSummary += [
              gsPrice.components.mainPrice ? 'основная - ' + gsPrice.components.mainPrice + ' руб.' : '',
              gsPrice.components.regionSurchargePrice ? 'надбавка за регионы - ' + gsPrice.components.regionSurchargePrice + ' руб.' : '',
              gsPrice.components.categoryClientSurchargePrice ? 'за проезд в ночное время - ' + gsPrice.components.categoryClientSurchargePrice + ' руб.' : ''
            ].filter(priceComponent => priceComponent).join(', ');
          }
          break;
        case 'OrderToFurniture':
          if (gsPrice.components.regionSurchargePrice
            || gsPrice.components.categoryClientSurchargePrice) {
            priceSummary += ': ';
            priceSummary += [
              gsPrice.components.mainPrice ? 'основная - ' + gsPrice.components.mainPrice + ' руб.' : '',
              gsPrice.components.regionSurchargePrice ? 'надбавка за регионы - ' + gsPrice.components.regionSurchargePrice + ' руб.' : '',
              gsPrice.components.categoryClientSurchargePrice ? 'за проезд в ночное время - ' + gsPrice.components.categoryClientSurchargePrice + ' руб.' : '',
              gsPrice.components.nightRate ? 'ночной тариф - ' + gsPrice.components.nightRate + ' руб.' : ''
            ].filter(priceComponent => priceComponent).join(', ');
          }
          break;
        case 'OrderToPetrol':
          if (!!gsPrice.components.categoryMinPriceTaken) {
            priceSummary += ': взята минимальная стоимость из справочника';
          }
          break;
        case 'OrderToGarbage':
          if (gsPrice.components.additionDayPrice
            || gsPrice.components.garbageDisposalDistrictPrice) {
            priceSummary += ': ';
            priceSummary += [
              gsPrice.components.mainPrice ? 'основная - ' + gsPrice.components.mainPrice + ' руб.' : '',
              gsPrice.components.additionDayPrice ? 'надбавка за доп.дни - ' + gsPrice.components.additionDayPrice + ' руб.' : '',
              gsPrice.components.garbageDisposalDistrictPrice ? 'за район вывоза мусора - ' + gsPrice.components.garbageDisposalDistrictPrice + ' руб.' : ''
            ].filter(priceComponent => priceComponent).join(', ');
          }
          break;
        case 'OrderToAdditional':
          break;
      }

      return priceSummary;
    },

    addOrRemoveShippingPacking (e) {
      if (this.order.status !== 2) { // отклонена
        if (e.target.checked) {
          let shippingPackingService

          this.$store.getters.additionalCategories.forEach(c => {
            if (c.shippingPacking) {
              shippingPackingService = {
                type: 'OrderToAdditional',
                pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToAdditional',
                category: c,
                address: this.addresses[0],
                date: this.order.datetime
              }
              shippingPackingService.address.id = 0

              this.$store.commit('addNewGroupedService', [shippingPackingService])
              this.hasShippingPackingInServices = true
            }
          })
        } else {
          this.groupedServices.forEach(gs => {
            if (gs[0].type == 'OrderToAdditional' && gs[0].category.shippingPacking) {
              this.$store.commit('deleteGroupedServiceByIndex', this.groupedServices.indexOf(gs))
              this.hasShippingPackingInServices = false
            }
          })
        }
      } else {
        e.target.checked = false
        this.hasShippingPackingInServices = false
        this.$refs.alertWindow.show('Ошибка', 'Для добавления услуги переведите статус заявки в "Ожидает"')
      }
    },

    checkHasShippingPackingInServices (groupedServices) {
      let has = false
      groupedServices.forEach(s => {
        if (s[0].type == 'OrderToAdditional' && s[0].category.shippingPacking) { has = true }
      })
      return has
    },

    getSmallAddressFromFull (address) {
      let smallAddress
      if (address.lat != null && address.lng != null) {
        smallAddress = utils.getSmallAddressFromFull(address.place) +
          (address.comment ? (', ' + address.comment) : '')
      } else {
        smallAddress = 'Адрес не указан'
      }
      return smallAddress
    },

    changeWorkerListWindowVisibility (value, type, serviceArray, serviceArrayIndex, categoryName, categoryId) {
      if (this.order.status !== 2) { // отклонена
        this.isWorkerListWindowVisible = value
        this.needfulWorkerType = type
        this.serviceArrayForWorkerList = serviceArray
        this.serviceArrayIndexForWorkerList = serviceArrayIndex
        this.categoryNameForWorkerList = categoryName
        this.categoryIdForWorkerList = categoryId
        utils.changeShadowVisibility(value)
      } else { this.$refs.alertWindow.show('Ошибка', 'Для назначения рабочих на услуги, переведите статус заявки в "Ожидает"') }
    },

    setOrderRealStartTimeToEachService () {
      this.groupedServices.forEach(gs => {
        gs.forEach(s => {
          s.realStartTime = this.order.realStartTime
        })
      });
      this.calculateSummaryServicePrice();
    },

    setOrderRealEndTimeToEachService () {
      this.groupedServices.forEach(gs => {
        gs.forEach(s => {
          s.realEndTime = this.order.realEndTime
        })
      });
      this.calculateSummaryServicePrice();
    },

    setOrderPredictionTimeToEachService() {
      this.groupedServices.forEach(gs => {
        gs.forEach(s => {
          s.predictionTime = this.order.predictionTime;
        });
      });
    },

    onOrderComplete () {
      if (this.canCompleteOrder && confirm('Вы уверены, что хотите подтвердить оплату?')) {
        api.completeOrder(this.order.id).then(() => {
          this.$refs.alertWindow.show('Подтверждено',
            'Вы подтвердили оплату. Заявка завершена и перемещена во вкладку «Завершенные заказы».', undefined,
            () => {
              this.$router.push('/orders')
            })
        }).catch(err => alert(err))
      }
    },

    moment (val) {
      return val ? moment(val) : moment()
    },

    addDatePickerWatcher() {
      // нужен для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

      this.$watch(
        () => {
          return this.$refs.datePicker.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.date = tmpValueForDatePicker;
            this.$refs.datePicker.popupVisible = false;
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePicker.userInput = '';
            this.$refs.datePicker.currentValue = null;
          }
        }
      );
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('request-page')
    this.$store.commit('updateGroupedServices', [])
    this.$store.commit('clearGroupedServicesPromises')
  }
}
</script>
